<button class="btn btn-default" type="button" [disabled]="locked" (click)="start()">
  Materialzuordnung Prüfen @if (locked) {
  <i class="fa fa-spin fa-circle-o-notch"></i>
}
</button>
